// extracted by mini-css-extract-plugin
export default {"productDescription":"wda-z","featuredDescription":"xda-z","description":"yda-z","more":"zda-z","descriptionSku":"Ada-z"};